/**
 * @generated SignedSource<<0730d02f258616daa29a0618b53fc286>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutItemPanelItemModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModuleDetails_user" | "PdpRespSimilarSoldItems_user">;
  readonly " $fragmentType": "PdpRespAboutItemPanelItemModule_user";
};
export type PdpRespAboutItemPanelItemModule_user$key = {
  readonly " $data"?: PdpRespAboutItemPanelItemModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanelItemModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpSimilarSoldItemsModuleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutItemPanelItemModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanelItemModuleDetails_user"
    },
    {
      "condition": "isPdpSimilarSoldItemsModuleVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarSoldItems_user"
            }
          ]
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d14e9b7adc602d491c9b8b8a306d3b44";

export default node;
